import { MAX_USING_FEE, MIN_USING_FEE } from '@/entities/map'
import { useMultiScrollState } from '@/shared/lib'

import { UsingFeeInDefaultView } from './default'
import { UsingFeeInDialogView } from './dialog'
import { Filter, FilterType, useFilter } from '../../../model/filter'

type Props = {
  className?: string
}

export const UsingFee = ({ className }: Props) => {
  const { registerScrollElement } = useMultiScrollState<HTMLDivElement>()

  const {
    type,
    filter: { minUsingFee, maxUsingFee },
    updateFilter,
  } = useFilter()

  const minUsingFeeValue = minUsingFee ?? MIN_USING_FEE
  const maxUsingFeeValue = maxUsingFee ?? MAX_USING_FEE

  const usingFeeRef = (element: HTMLDivElement) => {
    if (element) {
      registerScrollElement(Filter.UsingFee, element)
    }
  }

  const handleUsingFeeChange = ([min, max]: number[]) => {
    updateFilter({
      minUsingFee: min === MIN_USING_FEE ? null : min,
      maxUsingFee: max === MAX_USING_FEE ? null : max,
    })
  }

  if (type === FilterType.Dialog) {
    return (
      <UsingFeeInDialogView
        ref={usingFeeRef}
        value={[minUsingFeeValue, maxUsingFeeValue]}
        onValueChange={handleUsingFeeChange}
        className={className}
      />
    )
  }

  return (
    <UsingFeeInDefaultView
      ref={usingFeeRef}
      value={[minUsingFeeValue, maxUsingFeeValue]}
      onValueChange={handleUsingFeeChange}
      className={className}
    />
  )
}
